/**
 * 檢查錯誤是否為點數被上鎖錯誤
 * @typedef {Function} CHECK_POINT_IS_LOCKED
 * processing - 1 => 檢查鎖時發現有鎖噴錯
 * processing - 2 => 上鎖時，如果有鎖就會噴錯
 */
export const CHECK_POINT_IS_LOCKED = resp =>
    resp.httpStatus === 400 &&
    resp?.payload?.code === 'PSM-V0-F0' &&
    (resp?.payload?.message === 'Data processing - 1' ||
        resp?.payload?.message === 'Data processing - 2');
